(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('CompendiumSearch', CompendiumSearch);

    CompendiumSearch.$inject = ['$resource'];

    function CompendiumSearch($resource) {
        var resourceUrl =  'api/_search/compendiums/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
